exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".note-max-height[data-v-d45a10de]{height:100px;overflow:auto}.bg-purple[data-v-d45a10de]{background:purple;color:#fff}.text-purple[data-v-d45a10de]{color:purple}.max-status-height[data-v-d45a10de]{height:160px;overflow:auto}", ""]);

// exports
